import { z } from 'zod/v3';
import { ok } from 'neverthrow';
import {
  ActionResult,
  ApplicableContext,
  BaseAction,
  ExecuteContext,
  ActionTrackMetadata,
} from '@cotera/client/v0/actions/framework';
import { AgentModel } from './agent.model';
import type { ActionTrackingContext } from '../actions/framework/action-tracking';

type Params = {
  tab: string;
};

export class ChangeAgentTabAction extends BaseAction<
  Params,
  { t: string; message?: string }[]
> {
  title = 'Change Agent Tab';
  description = 'Switch between agent edit, chat, and split view tabs';
  inputSchema = z.object({
    tab: z.string(),
  });
  discrete = true;

  applicable(context: ApplicableContext): boolean {
    return context.hasTargetedModelOfType(AgentModel);
  }

  async execute(
    params: Params,
    context: ExecuteContext
  ): Promise<ActionResult<{ t: string; message?: string }[]>> {
    const agent = context.targetedModelOfType(AgentModel);

    if (agent === null) {
      return ok({});
    }

    agent.currentTab.set(params.tab);

    return ok({});
  }

  track({
    payload,
    context,
  }: ActionTrackingContext<
    Params,
    { t: string; message?: string }[]
  >): ActionTrackMetadata | null {
    const agent = context.targetedModelOfType(AgentModel);
    if (agent === null) {
      return null;
    }

    return {
      event: 'agent_tab_changed',
      properties: {
        agentId: agent.id,
        agentName: agent.name.snapshot(),
        toTab: payload.tab,
        hasMessages: agent.hasMessages.snapshot(),
      },
    };
  }
}
